import { generateTestId } from "@client-shared";

export const setAppLayoutTestId = (identifier: string): string => generateTestId("AppLayout", identifier);
